import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=101bd8d6&scoped=true&"
import script from "./collections.vue?vue&type=script&lang=js&"
export * from "./collections.vue?vue&type=script&lang=js&"
import style0 from "./collections.vue?vue&type=style&index=0&id=101bd8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101bd8d6",
  null
  
)

export default component.exports